import type { InputSource } from './types';

export const focusRings: InputSource = {
  label: 'Focus Rings',
  value: 'focusRings',
  draw: (ctx, width, height) => {
    ctx.clearRect(0, 0, width, height);

    const centerX = width * 0.5;
    const centerY = height * 0.5;
    const maxRadius = Math.min(width, height) * 0.48;

    const gradient = ctx.createRadialGradient(centerX, centerY, maxRadius * 0.05, centerX, centerY, maxRadius);
    gradient.addColorStop(0, '#ffffff');
    gradient.addColorStop(0.6, '#d2d6db');
    gradient.addColorStop(1, '#9aa1aa');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    ctx.strokeStyle = 'rgba(30, 30, 30, 0.7)';
    ctx.lineWidth = Math.max(2, Math.round(maxRadius * 0.01));
    const rings = 6;
    for (let i = 1; i <= rings; i += 1) {
      const radius = (maxRadius / rings) * i;
      ctx.beginPath();
      ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
      ctx.stroke();
    }

    ctx.strokeStyle = 'rgba(20, 20, 20, 0.8)';
    ctx.lineWidth = Math.max(2, Math.round(maxRadius * 0.012));
    ctx.beginPath();
    ctx.moveTo(centerX, centerY - maxRadius);
    ctx.lineTo(centerX, centerY + maxRadius);
    ctx.moveTo(centerX - maxRadius, centerY);
    ctx.lineTo(centerX + maxRadius, centerY);
    ctx.stroke();

    ctx.fillStyle = 'rgba(20, 20, 20, 0.8)';
    ctx.beginPath();
    ctx.arc(centerX, centerY, maxRadius * 0.02, 0, Math.PI * 2);
    ctx.fill();
  },
};
